import { atom } from "recoil";

export const loginErrorState = atom({
    key: 'loginErrorState',
    default: null,
})